import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=6fec3f3e&"
import script from "./ColorInput.vue?vue&type=script&lang=js&"
export * from "./ColorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports